import React from "react";

const SolutionProduct2 = () => {
  return (
    <section className="st-surface-cream overflow-x-clip py-14 sm:py-16 lg:py-20">
      <div className="mx-auto w-full max-w-6xl px-6 sm:px-8 lg:px-12">
        <div className="text-center">
          <h2 className="st-font-display mx-auto max-w-5xl text-[42px] leading-[0.98] text-[--st-color-heading] sm:text-[52px] lg:text-[68px]">
            <span className="block italic font-normal">Tenang. Kamu masih bisa kejar</span>
            <span className="block">
              skor <span className="font-semibold">6.5 </span><span className="italic font-normal">dalam</span> <span className="font-semibold">waktu singkat!</span>
            </span>
          </h2>

          <p className="st-font-body mx-auto mt-6 max-w-4xl text-[18px] leading-[1.45] text-[--st-color-text] sm:text-[20px] lg:text-[22px]">
            Di ScholarsToday, kamu mulai dari basic dulu, baru naik ke skill IELTS penuh. Terarah, terstruktur, dan ada garansinya!
          </p>
        </div>

        <div className="mt-9 flex justify-center sm:mt-10">
          <div className="w-full max-w-5xl rounded-[24px] bg-[--st-color-navy] px-6 py-4 text-center sm:px-8 sm:py-5 lg:px-10 lg:py-6">
            <p className="st-font-body text-[16px] font-bold uppercase tracking-[0.06em] text-white sm:text-[18px] lg:text-[22px]">
              Basic English for IELTS + Kelas Intensif
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SolutionProduct2;
